import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import UIButton from 'UIComponents/button/UIButton';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GetStartedButton = ({
  onTrack = emptyFunction
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('calling-free-account-upgrade');
  const handleClick = useCallback(() => {
    onTrack();
    openUpgradeModal();
  }, [onTrack, openUpgradeModal]);
  return /*#__PURE__*/_jsxs(UIButton, {
    use: "primary",
    onClick: handleClick,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `calling-orchestration-shared-library.unlock-calling.free-account-blocking.get-started-button-text`
    }), /*#__PURE__*/_jsx(UILockBadge, {})]
  });
};